import { type FC, useMemo } from "react";
import { FilterService } from "../../common/domain/service";
import { LenssourceModelLensSourceType as LensSourceType } from "../../../gql-generated/types";
import { useLensSources } from "../hooks/useLensSources";
import { type SourceModel } from "../models";
import { LensSourceList } from "./LensSourceList";

interface LensSourcesContainerProps {
    searchValue: string;
    type: LensSourceType;
    selectedItems: ReadonlyMap<string, SourceModel>;
    toggleSelection: (source: SourceModel) => void;
}

export const LensSourcesContainer: FC<LensSourcesContainerProps> = ({
    type,
    selectedItems,
    toggleSelection,
    searchValue,
}) => {
    const { sources, loading, loadMore, isLastPage } = useLensSources(type);

    const visibleSources = useMemo(
        () => new FilterService(searchValue).applyFilter(sources, (source) => source?.name ?? ""),
        [sources, searchValue],
    ) as Readonly<SourceModel[]>;

    return (
        <LensSourceList
            sources={visibleSources}
            loading={loading}
            toggleSelection={toggleSelection}
            selectedItems={selectedItems}
            loadMore={loadMore}
            isLastPage={isLastPage}
        />
    );
};
